import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=c2ad8ffa&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/blue-jays-ticketfinder/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ad8ffa"]])

export default __exports__